import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common'
import { UserService } from '@services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { PageService } from '@services/page.service';
import { NotificationsService } from '@services/notifications.service';
import { CookieService } from "ngx-cookie-service";

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
    loading = true;
    passwordStrength: number = 0
    username = '';
    verificationCode = '';
    newPw = '';
    confirmPw = '';
    policies: Object;
    verfifyMethod;
    passwordSent = false;
    error: string;
    constructor(
        private userService: UserService, 
        public location: Location, 
        private router: Router, 
        private page: PageService, 
        private notifications: NotificationsService, 
        private route: ActivatedRoute, 
        private cookieService: CookieService) { }

    ngOnInit() {
        // Forgot Password Page doesn't need menus
        this.page.updateHideMenu(true);
        this.route.queryParams.subscribe(params => {
            console.log("params", params)
            this.loading = true;
            this.verificationCode = params['token'];
            this.username = this.cookieService.get('forgot-username');
            console.log("verificationCode", this.verificationCode)
            if (this.verificationCode) {
                this.userService.getPasswordPolicy().subscribe(
                    (data) => {
                        this.policies = data;
                        this.loading = false;
                    },
                    (err) => {
                        this.loading = false;
                        // Unable to get the pw policy at this time
                    }
                )
            } else {
                this.loading = false;
            }
        });
    }

    hasSetTempPassword(){
        this.notifications.popNotification('','Please check your email for your temporary password.')
        this.router.navigate(['/login']);
    }

    startForgot() {
        this.loading = true;
        // var multi = merge(
        this.userService.triggerForgotPassword(this.username).subscribe(
            (pwData) => {
                this.cookieService.set('forgot-username', this.username, 10);
                this.passwordSent = true;
                this.loading = false;
            },
            (err) => {
                this.error =  err?.code == "LimitExceededException"?'Too many attempts at this time.': 'Unknown Error.'
                this.loading = false;
            },
            () => {}
        )
    }

  submitNewPw() {
    if (this.newPw !== this.confirmPw) {
      this.error = 'Passwords do not match!';
      return false;
    }
    this.userService.confirmPassword(this.verificationCode, this.newPw, this.username).subscribe(
            () => {
                // New pw set, go to scaffold
                console.log("you set your new pw?")
                this.router.navigate(['/login']);
            },
          (err) => {
            console.log(err)
            this.error = err.message;
            },
            () => {}
        )
    }
}
